import { Container, Row } from "reactstrap";
import { FormControlsTitle, TwoFactorTitle } from "../../../../../constants";
import EmailVerification from "./emailVerification";
import TwoFactorAuthentication from "./twoFactorAuthentication";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const TwoFactorContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={TwoFactorTitle} parent={FormControlsTitle} />
      <Container fluid>
        <Row>
          <TwoFactorAuthentication />
          <EmailVerification />
        </Row>
      </Container>
    </>
  );
};
export default TwoFactorContainer;
